import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const OrderInfoSkeleton = () => {
  const skeletonItems = Array.from({ length: 6 }, (_, index) => (
    <Grid key={index} size={{ xxs: 12, md: 4 }}>
      <Stack spacing={0.5} alignItems="center">
        <Skeleton variant="text" width="60%" height={24} />
        <Skeleton variant="rectangular" width="70%" height={28} sx={{ borderRadius: 1 }} />
      </Stack>
    </Grid>
  ));

  return (
    <Grid container spacing={2} width={1}>
      {skeletonItems}
    </Grid>
  );
};

export default OrderInfoSkeleton;
